import Card from "../components/Card";
import Screen1 from "../pictures/screen1.png";
import Screen2 from "../pictures/screen2.png";
const SecoundPage = () => {
  return (
    <div
      className="App-header"
      id="page-second"
      style={{
        width: "80%",
        height: "max-content",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "initial",
        margin: "auto",
      }}
    >
      <h2
        style={{
          writingMode: "vertical-lr",
          textTransform: "uppercase",
          fontSize: "12px",
          backgroundColor: "#FFB380",
          padding: "10px 0px",
        }}
      >
        some works
      </h2>
      <Card
        image={Screen1}
        text="portfolio"
        link="https://sijen.github.io/rajesh/"
      />
      <Card
        image={Screen2}
        text="printing press media website"
        link="https://sijen.github.io/press/"
      />
    </div>
  );
};
export default SecoundPage;
